module.exports = __webpack_public_path__ + "static/media/theatlantic_magazine_archive_2016_04_the-obama-doctrine_471525__plot.2d9e2921.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/theatlantic_magazine_archive_2016_04_the-obama-doctrine_471525__plot.png
// module id = 423
// module chunks = 0